var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 53,
    viewBox: "0 0 136 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.29 10.5238C46.0692 10.303 45.4805 10.2294 44.8182 10.2294C44.0822 10.2294 43.4935 10.4502 43.3463 10.671C43.3463 10.7446 43.2727 10.7446 43.2727 10.8182C43.2727 11.1126 44.0086 11.3333 44.8918 11.3333C45.7749 11.3333 46.4372 11.039 46.4372 10.7446C46.3636 10.671 46.3636 10.5974 46.29 10.5238Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7793 49.4546L48.2035 51.5888H40.9178L41.5801 49.0866H44.8918C45.5542 49.0866 46.0693 48.7186 46.0693 48.2035C46.0693 47.6883 45.5542 47.3204 44.8918 47.3204H42.0217L42.9784 43.7879L41.7273 43.4935L40.697 47.3204H23.7706L24.7273 43.7879L23.4762 43.4935L22.4459 47.3204H18.6927C18.0304 47.3204 17.5152 47.6883 17.5152 48.2035C17.5152 48.7186 18.0304 49.0866 18.6927 49.0866H22.0044L21.342 51.5888H15.3074L12.7317 49.4546L12.5845 50.7056L14.8659 52.8398H48.7187L50.9265 50.7056L50.7793 49.4546ZM23.2555 49.0866H40.1819L39.5195 51.5888H22.5931L23.2555 49.0866Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.684 12.9524C59.6104 12.5844 59.1689 12.2901 58.8009 12.2901C37.3117 9.86149 22.9611 16.3377 22.5195 17.5888C22.4459 17.8831 24.065 19.2078 24.5065 19.1342C36.723 17.6624 48.3507 17.2944 60.6407 18.3983C61.0823 18.4719 61.3031 18.2511 61.2295 17.8831C60.6407 16.1905 60.1992 14.5714 59.684 12.9524Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6625 14.3507C65.9396 12.0693 57.4028 12.5108 57.4028 12.5108L57.1084 15.5282L67.4114 19.6494C67.485 19.6494 69.2513 17.5152 68.6625 14.3507Z",
    fill: "#414042"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.736 14.7186C66.0131 12.4372 57.4763 12.8788 57.4763 12.8788L57.1819 15.8961L67.4849 20.0173C67.5585 20.0173 69.3247 17.8831 68.736 14.7186Z",
    fill: "url(#paint0_radial_334_30690)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.221 20.0173L66.6755 20.0173V24.3593L103.031 23.7706L102.221 20.0173Z",
    fill: "#F4777C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8052 17.8096C97.8052 17.5888 97.5844 17.368 97.3637 17.368H91.1082C90.8875 17.368 90.6667 17.5888 90.6667 17.8096L88.0173 20.3853C88.0173 20.6061 88.2381 20.8269 88.4589 20.8269H97.3637C97.5844 20.8269 97.8052 20.6061 97.8052 20.3853V17.8096Z",
    fill: "#F4777C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.442 20.3853L66.9697 20.3853V24.7273L103.251 24.0649L102.442 20.3853Z",
    fill: "url(#paint1_radial_334_30690)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0565 36.7965C14.0565 34.5887 13.3941 28.4069 10.3768 29.3636C7.21231 30.3939 2.06079 34.0736 2.06079 36.2814C2.06079 38.4892 8.09543 41.3593 11.4071 41.3593C14.7188 41.4329 14.0565 39.0043 14.0565 36.7965Z",
    fill: "url(#paint2_radial_334_30690)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06079 36.4286C2.28157 38.6364 8.16902 41.4329 11.4071 41.4329C14.0565 41.4329 14.1301 39.8874 14.1301 38.1212C8.83135 38.342 4.56296 37.3853 2.06079 36.4286Z",
    fill: "url(#paint3_radial_334_30690)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0864 28.7749C73.3721 15.6017 51.5886 14.4978 35.5453 14.4978C19.502 14.4978 6.84399 31.1299 6.84399 35.7662C6.84399 42.9784 20.1643 45.039 36.2076 44.5238C53.502 43.9351 61.9652 36.355 66.0864 28.7749Z",
    fill: "url(#paint4_linear_334_30690)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4933 16.1169C15.0128 20.1645 6.84399 30.6147 6.84399 34V34.0736C7.35915 34.1472 7.8743 34.2944 8.53664 34.1472C10.3765 33.8528 11.9955 33.2641 12.4371 33.7792C12.4371 33.7792 12.5107 33.8528 12.5107 33.9264C13.9089 30.8355 17.6622 26.6407 21.3418 23.9178C23.7704 22.1515 25.5366 23.0346 26.7877 21.71C27.7444 20.8269 25.5366 18.7662 25.5366 18.7662C26.1254 18.7662 26.7877 18.6927 27.3765 18.6191C26.9349 17.8831 26.6405 17.0736 26.4933 16.1169Z",
    fill: "url(#paint5_radial_334_30690)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1989 15.6753L56.8872 21.1212L60.0517 24.8744H68.1469L69.8396 20.0173L60.1989 15.6753Z",
    fill: "url(#paint6_linear_334_30690)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7578 13.1732C59.6842 12.8052 59.2426 12.5108 58.8746 12.5108C37.3855 10.0823 23.0348 16.5584 22.5933 17.8095C22.5197 18.1039 24.1387 19.4286 24.5803 19.355C36.7967 17.8831 48.4244 17.5152 60.7145 18.619C61.156 18.6926 61.3768 18.4719 61.3032 18.1039C60.788 16.4113 60.2729 14.7922 59.7578 13.1732Z",
    fill: "url(#paint7_radial_334_30690)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1646 29.1429C71.1646 21.1212 57.6235 14.5714 40.9179 14.5714C24.2123 14.5714 10.6711 21.0476 10.6711 29.1429C10.6711 37.1645 24.2123 43.7143 40.9179 43.7143C57.6971 43.7143 71.1646 37.1645 71.1646 29.1429Z",
    fill: "url(#paint8_radial_334_30690)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.922 4.70996H43.6406V13.1732H45.922V4.70996Z",
    fill: "url(#paint9_linear_334_30690)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6581 21.4892C61.156 18.3247 57.182 17 50.2642 17C46.511 17 42.169 17.368 37.0911 17.8095C33.6322 18.1039 29.7317 18.4719 25.5369 18.6926H25.2426L25.4634 18.8398C25.4634 18.8398 26.9352 20.1645 26.9352 21.1212C26.9352 21.342 26.8616 21.4892 26.7144 21.6364C26.1257 22.2251 25.4634 22.3723 24.6538 22.4459C23.6971 22.5931 22.5932 22.8138 21.2685 23.7706C16.853 27.0087 11.9222 32.8225 11.8486 35.8398C11.8486 36.5022 12.0694 36.9437 12.4374 37.3117C14.2772 38.7836 18.5456 39.5195 25.169 39.5195C35.84 39.5195 51.0001 37.4589 56.8876 35.6926C56.8876 35.6926 59.5369 33.3377 61.6711 30.4675C64.6149 26.5671 65.2772 23.4762 63.6581 21.4892Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6102 18.7662C25.6102 18.7662 27.818 20.7532 26.8613 21.7099C25.5366 22.961 23.7704 22.0779 21.4154 23.9177C15.9695 27.9654 10.2293 35.3247 12.6578 37.3117C18.3981 41.8744 48.4977 38.1948 56.9609 35.619C56.9609 35.619 67.4111 26.4199 63.6578 21.5628C58.0648 14.4978 45.186 17.5887 25.6102 18.7662Z",
    fill: "url(#paint10_linear_334_30690)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4847 29.4372L77.1989 29.5108L74.6968 26.3463H81.9825L84.4847 29.4372Z",
    fill: "url(#paint11_radial_334_30690)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56721 38.342C9.64081 38.1212 9.7144 37.9005 9.78799 37.6797C10.4503 36.2078 11.5542 35.1775 11.0391 34.736C10.5975 34.2944 8.97847 34.8095 7.13864 35.1039C7.06505 35.1039 6.99146 35.1039 6.99146 35.1039C7.28583 36.355 8.16894 37.4589 9.56721 38.342Z",
    fill: "url(#paint12_radial_334_30690)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4371 33.7792C11.9955 33.3377 10.3765 33.8528 8.53664 34.1472C7.8743 34.2208 7.35915 34.0736 6.84399 34.0736C6.84399 34.4416 6.91759 34.7359 6.99118 35.1039C7.06478 35.1039 7.13837 35.1039 7.13837 35.1039C8.97819 34.8095 10.5972 34.2208 11.0388 34.7359C11.554 35.2511 10.3765 36.2814 9.78772 37.6797C9.71412 37.9005 9.64053 38.1212 9.56694 38.342C9.93491 38.5628 10.3029 38.7836 10.7444 39.0043C10.818 38.342 10.818 37.4589 11.186 36.723C11.8483 35.3247 12.9522 34.2944 12.4371 33.7792Z",
    fill: "url(#paint13_linear_334_30690)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0994 18.1775C98.0994 17.9567 97.8786 17.736 97.6579 17.736H91.4024C91.1817 17.736 90.9609 17.9567 90.9609 18.1775L88.3115 20.7533C88.3115 20.9741 88.5323 21.1948 88.7531 21.1948H97.5843C97.805 21.1948 98.0258 20.9741 98.0258 20.7533V18.1775H98.0994Z",
    fill: "url(#paint14_radial_334_30690)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0735 24.6537H84.1904H83.0129L69.7661 24.7273L72.1211 27.2295L83.0129 27.1559H85.0735H85.1471C85.3679 27.0823 85.515 26.9351 85.515 26.7143V25.0953C85.515 24.8745 85.2943 24.6537 85.0735 24.6537Z",
    fill: "url(#paint15_linear_334_30690)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M120.913 12.8788H114.364L122.532 4.70996H129.009L120.913 12.8788Z",
    fill: "url(#paint16_linear_334_30690)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M118.632 20.4589C118.632 18.7662 118.117 17.2944 117.234 15.9697L120.104 13.1732H113.554L122.385 4.342H129.082L131.216 2.28139L120.398 2.28139L108.476 12.8052C108.182 12.8788 107.961 12.9524 107.74 13.0996H102L93.3159 21.4892H97.7315H99.7921L102.515 24.2121L110.684 32.381H124.078L117.013 25.316C118.043 23.9178 118.632 22.2987 118.632 20.4589ZM110.905 25.5368C109.727 25.5368 108.623 25.1688 107.74 24.4329C106.489 23.4762 105.68 21.9307 105.68 20.2381C105.68 17.368 108.035 15.013 110.905 15.013C112.892 15.013 114.584 16.1169 115.541 17.7359C115.983 18.4719 116.203 19.355 116.203 20.3117C116.13 23.1818 113.775 25.5368 110.905 25.5368Z",
    fill: "url(#paint17_radial_334_30690)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M118.485 20.3853C118.485 18.6927 117.97 17.2208 117.087 15.8961L119.957 13.0996H113.407L122.238 4.26841H128.935L131.069 2.20781L120.251 2.20781L108.329 12.7316C108.108 12.8052 107.814 12.8788 107.593 13.026H101.927L93.1689 21.342H97.5845H99.6451L102.368 24.0649L110.537 32.2338H123.931L116.866 25.1688C117.896 23.8442 118.485 22.1515 118.485 20.3853ZM110.684 25.3896C109.507 25.3896 108.403 25.0217 107.52 24.2857C106.269 23.329 105.459 21.7836 105.459 20.0909C105.459 17.2208 107.814 14.8658 110.684 14.8658C112.671 14.8658 114.364 15.9697 115.32 17.5888C115.762 18.3247 115.983 19.2078 115.983 20.1645C115.983 23.0346 113.628 25.3896 110.684 25.3896Z",
    fill: "#F14950"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M118.632 20.4589C118.632 18.7662 118.117 17.2944 117.234 15.9697L120.104 13.1732H113.554L122.385 4.342H129.082L131.216 2.28139L120.398 2.28139L108.476 12.8052C108.182 12.8788 107.961 12.9524 107.74 13.0996H102L93.3159 21.4892H97.7315H99.7921L102.515 24.2121L110.684 32.381H124.078L117.013 25.316C118.043 23.9178 118.632 22.2987 118.632 20.4589ZM110.905 25.5368C109.727 25.5368 108.623 25.1688 107.74 24.4329C106.489 23.4762 105.68 21.9307 105.68 20.2381C105.68 17.368 108.035 15.013 110.905 15.013C112.892 15.013 114.584 16.1169 115.541 17.7359C115.983 18.4719 116.203 19.355 116.203 20.3117C116.13 23.1818 113.775 25.5368 110.905 25.5368Z",
    fill: "url(#paint18_radial_334_30690)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M110.905 19.9437L111.273 17.6624L111.641 15.6017C111.42 15.6017 111.199 15.5282 110.905 15.5282C110.684 15.5282 110.389 15.5282 110.169 15.6017L110.537 17.6624L110.905 19.9437Z",
    fill: "url(#paint19_radial_334_30690)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M110.537 20.2381L108.256 19.8702L106.195 19.5022C106.195 19.723 106.121 19.9438 106.121 20.2381C106.121 20.4589 106.121 20.7533 106.195 20.9741L108.256 20.6061L110.537 20.2381Z",
    fill: "url(#paint20_radial_334_30690)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M110.905 20.6061L110.537 22.8875L110.169 24.9481C110.389 24.9481 110.61 25.0217 110.905 25.0217C111.125 25.0217 111.42 25.0217 111.641 24.9481L111.273 22.8875L110.905 20.6061Z",
    fill: "url(#paint21_radial_334_30690)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M111.199 20.3117L113.48 20.6797L115.541 21.0476C115.541 20.8269 115.615 20.6061 115.615 20.3117C115.615 20.0909 115.615 19.7966 115.541 19.5758L113.48 19.9437L111.199 20.3117Z",
    fill: "url(#paint22_radial_334_30690)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M134.307 0.294373C134.16 0.294373 134.087 0.294371 133.939 0.367965L119.442 0.367965C119.368 0.367965 119.221 0.294373 119.074 0.294373C118.411 0.294373 117.823 0.809522 117.823 1.54545C117.823 2.20779 118.338 2.79653 119.074 2.79653C119.221 2.79653 119.294 2.79653 119.442 2.72294L133.939 2.72294C134.013 2.72294 134.16 2.79653 134.307 2.79653C134.97 2.79653 135.558 2.28138 135.558 1.54545C135.485 0.883115 134.97 0.294373 134.307 0.294373Z",
    fill: "#B70E12"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M134.749 0.441574C134.602 0.441574 134.528 0.441573 134.381 0.515166L119.883 0.515166C119.81 0.515166 119.662 0.441574 119.515 0.441574C118.853 0.441574 118.264 0.956723 118.264 1.69265C118.264 2.35499 118.779 2.94374 119.515 2.94374C119.662 2.94374 119.736 2.94374 119.883 2.87015L134.381 2.87015C134.455 2.87015 134.602 2.94374 134.749 2.94374C135.411 2.94374 136 2.42858 136 1.69265C136 0.956723 135.411 0.441574 134.749 0.441574Z",
    fill: "url(#paint23_linear_334_30690)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M115.762 19.5022V19.355L111.42 20.0909L115.026 17.5152L114.953 17.368C114.805 17.1472 114.658 17 114.437 16.7792C114.29 16.632 114.069 16.4113 113.849 16.2641L113.701 16.1905L111.126 19.7966L111.862 15.4546H111.714C111.199 15.381 110.684 15.381 110.243 15.4546H110.095L110.831 19.7966L108.256 16.1905L108.108 16.2641C107.888 16.4113 107.74 16.5585 107.52 16.7792C107.372 16.9264 107.152 17.1472 107.004 17.368L106.931 17.5152L110.537 20.0909L106.195 19.355V19.5022C106.121 19.723 106.121 20.0173 106.121 20.2381C106.121 20.4589 106.121 20.7533 106.195 20.974V21.1212L110.537 20.3853L106.931 22.9611L107.004 23.1082C107.152 23.329 107.299 23.4762 107.52 23.697C107.667 23.8442 107.888 24.065 108.108 24.2121L108.256 24.2857L110.831 20.6797L110.095 25.0217H110.243C110.463 25.0953 110.758 25.0953 110.978 25.0953C111.199 25.0953 111.494 25.0953 111.714 25.0217H111.862L111.126 20.6797L113.701 24.2857L113.849 24.2121C114.069 24.065 114.217 23.9178 114.437 23.697C114.585 23.5498 114.805 23.329 114.953 23.1082L115.026 22.9611L111.42 20.3853L115.762 21.1212V20.974C115.836 20.7533 115.836 20.4589 115.836 20.2381C115.836 20.0173 115.762 19.7966 115.762 19.5022Z",
    fill: "url(#paint24_radial_334_30690)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M110.905 18.9134C110.169 18.9134 109.58 19.5021 109.58 20.2381C109.58 20.6796 109.801 21.0476 110.095 21.2684C110.316 21.4156 110.611 21.5627 110.905 21.5627C111.641 21.5627 112.23 20.974 112.23 20.2381C112.23 20.0173 112.156 19.7965 112.082 19.5757C111.862 19.2078 111.42 18.9134 110.905 18.9134Z",
    fill: "url(#paint25_radial_334_30690)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2292 23.329C25.6102 23.6234 24.3591 23.9914 23.476 24.4329C20.9002 25.7576 16.1903 32.3074 15.9695 32.6018L15.4543 33.3377H16.3375C16.4846 33.3377 20.0907 33.3377 24.8007 33.0433H25.095L27.8916 23.2554L27.2292 23.329Z",
    fill: "url(#paint26_linear_334_30690)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5844 22.6667C46.5844 22.6667 44.0086 22.5195 40.6234 22.5195H40.2554L38.0476 31.1299L38.7835 30.9091C41.3593 30.1732 43.2727 29.2901 44.3766 28.2598C45.2597 27.3767 46.7316 23.697 46.9524 23.2555L47.1731 22.6667H46.5844Z",
    fill: "url(#paint27_linear_334_30690)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6971 24.8745C21.1949 26.1991 16.4114 32.8961 16.4114 32.8961C16.4114 32.8961 20.091 32.8961 24.801 32.6017L27.3032 23.8442C25.8313 24.0649 24.5802 24.4329 23.6971 24.8745Z",
    fill: "url(#paint28_radial_334_30690)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7403 22.0779L29.2165 22.8139C28.8485 22.8139 28.6277 23.1082 28.6277 23.4026L24.2122 38.5628V38.6364C24.2122 38.9307 24.5065 39.2251 24.8009 39.2251L35.6191 38.342C35.987 38.342 36.2078 38.1212 36.2078 37.7533L40.329 22.6667V22.5931C40.329 22.2987 40.0347 22.0779 39.7403 22.0779Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1817 22.6667C40.1817 22.4459 39.961 22.2251 39.7402 22.2251L29.1428 22.961C28.922 22.961 28.7012 23.1818 28.7012 23.4026L24.2856 38.5628C24.2856 38.7835 24.5064 39.0043 24.7272 39.0043L35.5454 38.1212C35.7662 38.1212 35.9869 37.9004 35.9869 37.6796L40.1817 22.6667Z",
    fill: "url(#paint29_linear_334_30690)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2985 22.5195C35.3245 22.5195 31.9392 22.7402 29.2898 23.0346L28.9955 23.1082L26.5669 32.0866V32.1601C26.5669 32.3073 26.6405 32.5281 26.7141 32.6753L26.8613 32.8961H27.1556C31.2033 32.5281 34.7357 32.013 37.4587 31.3506L37.753 31.277L39.8872 22.5195H39.2985Z",
    fill: "url(#paint30_linear_334_30690)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2898 23.4762L26.9348 32.0866C26.9348 32.1602 26.9348 32.2338 27.0084 32.3074C30.3937 32.013 34.0733 31.5714 37.3114 30.7619L39.2985 22.8874C36.1339 22.961 32.4543 23.1082 29.2898 23.4762Z",
    fill: "url(#paint31_radial_334_30690)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5844 23.1082C46.5844 23.1082 44.0823 22.9611 40.6234 22.9611L38.71 30.4676C41.0649 29.8052 42.9784 28.9957 44.0823 27.8918C45.039 27.0823 46.5844 23.1082 46.5844 23.1082Z",
    fill: "url(#paint32_radial_334_30690)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1385 41.1385C58.4329 40.6234 57.1082 39.2987 55.1948 38.1212C53.2814 36.9437 51.4415 36.4286 51.1472 36.9437C50.8528 37.4589 52.1775 38.7835 54.0909 39.961C56.0779 41.1385 57.8441 41.6537 58.1385 41.1385Z",
    fill: "url(#paint33_linear_334_30690)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6146 31.2035C64.541 31.1299 64.4675 31.1299 64.3203 31.0563C62.1125 30.0996 59.3159 30.3939 56.0043 32.8225C53.7965 34.4415 52.1038 35.7662 51.2207 36.8701C51.6623 36.5022 53.3549 37.0173 55.1947 38.1212C55.7835 38.4892 56.2986 38.8571 56.7402 39.1515C62.3333 36.6493 64.0995 32.9697 64.6146 31.2035Z",
    fill: "url(#paint34_radial_334_30690)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6147 31.2035C64.0995 32.9697 62.3333 36.5758 56.7402 39.1515C57.7705 39.961 58.3593 40.697 58.1385 41.0649C59.1688 40.697 60.3463 39.961 61.671 38.7835C64.6147 36.2078 68.2208 33.0433 64.6147 31.2035Z",
    fill: "url(#paint35_radial_334_30690)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1472 37.0173L51.2208 36.9437C51.2208 36.9437 51.2208 36.9437 51.1472 37.0173Z",
    fill: "url(#paint36_radial_334_30690)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0259 18.6927C29.9523 18.6191 30.0259 18.6191 30.0259 18.6927C29.4371 18.1775 28.922 18.1039 28.4804 18.1039C28.4068 18.1039 28.2596 18.1039 28.1861 18.1039C28.1125 18.1039 28.0389 18.1039 27.9653 18.1039C27.7445 18.1039 27.4501 18.1039 27.3029 17.9567C26.7878 17.5888 26.4198 17.0736 26.1255 16.7056C25.7575 16.1905 25.3895 15.6753 24.8008 15.5282C24.7272 15.5282 24.6536 15.5282 24.6536 15.5282C24.1384 15.5282 23.6969 15.9697 23.1817 16.5585C22.7402 17 22.3722 17.4416 21.857 17.6624C21.5627 17.8095 21.4891 18.0303 21.5627 18.1039C21.6363 18.987 24.8008 19.9437 24.8008 19.9437C25.2423 20.0909 25.9047 20.1645 26.8614 20.1645C28.1125 20.1645 29.4371 20.0909 30.0995 20.0173C30.3938 20.0173 30.541 19.7965 30.6146 19.723C30.7618 19.355 30.3203 18.9134 30.0259 18.6927Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008 15.6753C25.7575 15.8961 26.0519 17.2208 27.2294 18.1039C27.8181 18.5455 28.9956 17.8831 29.9523 18.7663C30.1731 18.987 30.6883 19.4286 30.5411 19.6494C30.4675 19.723 30.3939 19.8702 30.0995 19.8702C28.9956 19.9437 26.0519 20.2381 24.8744 19.8702C23.9913 19.6494 20.7532 18.3983 21.9307 17.8095C23.0346 17.0736 23.9177 15.4546 24.8008 15.6753Z",
    fill: "url(#paint37_linear_334_30690)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5411 4.04763C47.5411 4.04763 45.7749 4.12122 43.7879 4.26841C41.8009 4.12122 40.0346 4.04763 40.0346 4.04763C40.0346 4.04763 12.1429 2.94374 0 9.93508L2.42857 10.9654C2.42857 10.9654 11.9957 5.00434 39.8874 5.07794C41.4329 5.07794 42.7576 5.07794 43.8615 5.07794C44.9654 5.07794 46.29 5.07794 47.8355 5.07794C75.6537 5.00434 85.2944 10.9654 85.2944 10.9654L87.7229 9.93508C75.5065 2.94374 47.5411 4.04763 47.5411 4.04763Z",
    fill: "url(#paint38_linear_334_30690)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7576 4.34201C42.7576 4.34201 18.1775 7.5801 9.052 15.6017L11.3334 16.1169C11.3334 16.1169 18.4719 9.49352 42.7576 5.29872C43.7879 5.15153 44.7446 4.93076 45.5542 4.78357C45.3334 4.56279 45.1126 4.34201 44.8918 4.12123C43.7143 4.19482 42.7576 4.34201 42.7576 4.34201Z",
    fill: "url(#paint39_linear_334_30690)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1731 4.78359C47.1731 4.78359 67.7791 7.50653 75.4328 14.2035L73.5194 14.6451C73.5194 14.6451 67.5584 9.05198 47.1731 5.59311C46.29 5.44592 45.4805 5.29874 44.8181 5.15155C44.9653 4.93077 45.1861 4.78358 45.4069 4.56281C46.3636 4.6364 47.1731 4.78359 47.1731 4.78359Z",
    fill: "url(#paint40_linear_334_30690)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5715 44.3766C48.5715 43.8615 47.9092 43.4935 47.1733 43.4935H17.8096C17.0001 43.4935 16.4114 43.8615 16.4114 44.3766V45.2597C16.4114 45.7749 17.0737 46.1429 17.8096 46.1429H47.1733C47.9828 46.1429 48.5715 45.7749 48.5715 45.2597V44.3766Z",
    fill: "url(#paint41_radial_334_30690)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0392 1.69267H44.524L40.918 1.69267L42.0955 6.99138H44.524H45.0392H47.4677L48.6452 1.69267L45.0392 1.69267Z",
    fill: "url(#paint42_radial_334_30690)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5542 0.294404C45.407 0.147218 45.1862 3.05176e-05 44.8183 3.05176e-05C44.5239 3.05176e-05 44.2295 0.147218 44.0824 0.294404C41.9482 0.44159 40.3291 1.17752 40.3291 2.06063C40.3291 3.01734 42.3161 3.82687 44.8183 3.82687C47.3204 3.82687 49.3075 3.01734 49.3075 2.06063C49.3075 1.17752 47.6884 0.44159 45.5542 0.294404Z",
    fill: "url(#paint43_radial_334_30690)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5366 39.6667L22.6665 42.4632H25.3895L28.186 39.6667H25.5366Z",
    fill: "url(#paint44_radial_334_30690)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2163 39.6667L26.3462 42.4632H29.0691L31.8657 39.6667H29.2163Z",
    fill: "url(#paint45_radial_334_30690)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8569 39.6667L18.9868 42.4632H21.7098L24.5063 39.6667H21.8569Z",
    fill: "url(#paint46_radial_334_30690)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M32.896 39.6667L30.0259 42.4632H32.7488L35.5454 39.6667H32.896Z",
    fill: "url(#paint47_radial_334_30690)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5019 39.6667L33.7053 42.4632H36.4283L39.2248 39.6667H36.5019Z",
    fill: "url(#paint48_radial_334_30690)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3376 29.8052L40.1818 39.6667L37.3853 42.4632H41.4329L52.8398 31.4242C51.8831 31.1299 51 30.5411 50.3376 29.8052Z",
    fill: "url(#paint49_radial_334_30690)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3723 15.8961C56.0043 14.4243 55.71 12.8788 55.342 11.4069C55.2684 11.1126 54.974 10.8182 54.7533 10.7446C51.8831 10.303 49.013 10.1559 46.1429 10.2295C46.2165 10.303 46.2901 10.3766 46.2901 10.4502C46.2901 10.7446 45.6277 11.039 44.7446 11.039C43.8615 11.039 43.1991 10.8182 43.1256 10.5238C43.1256 10.4502 43.1256 10.4502 43.1992 10.3766C39.8875 10.671 36.6494 11.2598 33.4113 12.2165C33.1905 12.2901 32.8961 12.5108 32.8225 12.8052C32.5282 13.9827 32.2338 15.0866 31.9394 16.2641C31.8658 16.4849 32.013 16.632 32.3074 16.5585C40.2554 15.3074 47.9091 15.0866 55.9307 16.2641C56.2987 16.4113 56.4459 16.1905 56.3723 15.8961Z",
    fill: "#F14950"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4463 16.1169C56.0783 14.6451 55.7839 13.0996 55.416 11.6277C55.3424 11.3334 55.048 11.039 54.8272 10.9654C51.9571 10.5238 49.087 10.3767 46.2168 10.4502C46.2904 10.5238 46.364 10.5974 46.364 10.671C46.364 10.9654 45.7017 11.2598 44.8186 11.2598C43.9355 11.2598 43.2731 11.039 43.1995 10.7446C43.1995 10.671 43.1995 10.671 43.2731 10.5974C39.9614 10.8918 36.7233 11.4806 33.4852 12.4373C33.2645 12.5109 32.9701 12.7316 32.8965 13.026C32.6021 14.2035 32.3078 15.3074 32.0134 16.4849C31.9398 16.7057 32.087 16.8528 32.3813 16.7792C40.3294 15.5282 47.9831 15.3074 56.0047 16.4849C56.3727 16.6321 56.5199 16.4113 56.4463 16.1169Z",
    fill: "url(#paint50_radial_334_30690)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7272 24.7273L57.6969 22.9611L55.6362 24.1386V21.7836H53.5756V24.1386L51.515 22.9611L50.4111 24.7273L52.4717 25.9784L50.4111 27.1559L51.515 28.9957L53.5756 27.7446V30.1732H55.6362V27.7446L57.6969 28.9957L58.7272 27.1559L56.6665 25.9784L58.7272 24.7273Z",
    fill: "url(#paint51_radial_334_30690)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.4962 13.6807) rotate(6.89761) scale(9.98769 9.98769)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.1859 31.5967) scale(20.943 20.943)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F02210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B201C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.8997 29.7806) scale(9.31114 12.4537)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0537634,
    stopColor: "#CC462A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#C93428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#C72527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5211,
    stopColor: "#C62026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#901114"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.62864 36.1867) scale(6.25644 6.25644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1129,
    stopColor: "#A21A1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C0D0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_334_30690",
    x1: 6.83921,
    y1: 29.5718,
    x2: 67.5634,
    y2: 29.5718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1327,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9193,
    stopColor: "#E0E0DF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.1188 25.1529) scale(9.685 9.68499)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_334_30690",
    x1: 56.9018,
    y1: 20.2735,
    x2: 69.8395,
    y2: 20.2735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.080695,
    stopColor: "#E0E0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8673,
    stopColor: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.8794 13.2144) rotate(-2.39916) scale(18.3334 14.6346)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1327,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9193,
    stopColor: "#E0E0DF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.9698 29.1411) scale(30.2211 14.5404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0954357,
    stopColor: "#2A2627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2367,
    stopColor: "#3E3A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4064,
    stopColor: "#5E5B5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5982,
    stopColor: "#8B8989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8058,
    stopColor: "#C3C2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_334_30690",
    x1: 43.6685,
    y1: 8.9799,
    x2: 45.9496,
    y2: 8.9799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1327,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8883,
    stopColor: "#9A9C9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_334_30690",
    x1: 12.0126,
    y1: 28.2314,
    x2: 64.4002,
    y2: 28.2314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.080695,
    stopColor: "#E0E0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8673,
    stopColor: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.9879 35.6886) rotate(-0.343771) scale(11.1198 11.1198)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0537634,
    stopColor: "#CC462A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#C93428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#C72527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5211,
    stopColor: "#C62026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#901114"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.06737 36.4357) scale(2.01152)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_334_30690",
    x1: 6.84171,
    y1: 36.3276,
    x2: 12.5773,
    y2: 36.3276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1327,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9193,
    stopColor: "#E0E0DF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.5312 25.6079) scale(7.68231 7.6823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0537634,
    stopColor: "#CC462A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#C93428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#C72527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5211,
    stopColor: "#C62026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#901114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_334_30690",
    x1: 69.7053,
    y1: 25.9541,
    x2: 85.5242,
    y2: 25.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.080695,
    stopColor: "#E0E0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8673,
    stopColor: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_334_30690",
    x1: 114.39,
    y1: 8.79592,
    x2: 129.017,
    y2: 8.79592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#720D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A81B20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.244 17.3434) scale(17.0764 17.0764)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0537634,
    stopColor: "#CC462A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#C93428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#C72527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5211,
    stopColor: "#C62026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#901114"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.217 17.3434) scale(22.1395 22.1395)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0537634,
    stopColor: "#CC462A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#C93428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#C72527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5211,
    stopColor: "#C62026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#901114"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.898 17.7166) scale(1.63818)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0537634,
    stopColor: "#CC462A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#C93428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#C72527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5211,
    stopColor: "#C62026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#901114"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.335 20.2532) scale(1.6384)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0537634,
    stopColor: "#CC462A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#C93428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#C72527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5211,
    stopColor: "#C62026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#901114"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.87 22.8167) scale(1.6384)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0537634,
    stopColor: "#CC462A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#C93428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#C72527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5211,
    stopColor: "#C62026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#901114"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.435 20.2801) scale(1.63855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0537634,
    stopColor: "#CC462A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#C93428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#C72527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5211,
    stopColor: "#C62026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#901114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_334_30690",
    x1: 118.386,
    y1: 1.66359,
    x2: 135.992,
    y2: 1.66359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#720D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A81B20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.884 20.2665) scale(4.92602)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1327,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8883,
    stopColor: "#9A9C9D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.899 20.2664) scale(1.31812 1.31812)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0537634,
    stopColor: "#CC462A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#C93428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#C72527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5211,
    stopColor: "#C62026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#901114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_334_30690",
    x1: 15.482,
    y1: 28.2627,
    x2: 27.94,
    y2: 28.2627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F02210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A2118"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_334_30690",
    x1: 38.1233,
    y1: 26.826,
    x2: 47.2627,
    y2: 26.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F02210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A2118"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2143 26.3159) scale(11.2388 11.2388)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_334_30690",
    x1: 24.2968,
    y1: 30.6168,
    x2: 40.1599,
    y2: 30.6168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.080695,
    stopColor: "#E0E0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8673,
    stopColor: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_334_30690",
    x1: 26.5099,
    y1: 27.6808,
    x2: 39.8651,
    y2: 27.6808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F02210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A2118"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.5165 24.0961) scale(13.4173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.6154 26.3155) scale(11.2395 11.2395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_334_30690",
    x1: 51.186,
    y1: 37.0064,
    x2: 58.2496,
    y2: 41.0008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2333,
    stopColor: "#413E3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4286,
    stopColor: "#363435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6101,
    stopColor: "#252324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7823,
    stopColor: "#0D0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.4047 31.7443) scale(10.0841 10.0841)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1327,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9193,
    stopColor: "#E0E0DF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.4433 36.2065) scale(4.83175 4.83175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0537634,
    stopColor: "#CC462A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#C93428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#C72527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5211,
    stopColor: "#C62026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#901114"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.5908 39.0264) rotate(30.6837) scale(2.94275 2.37165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_334_30690",
    x1: 21.5764,
    y1: 17.8162,
    x2: 30.4792,
    y2: 17.8162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.080695,
    stopColor: "#E0E0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8673,
    stopColor: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_334_30690",
    x1: -0.022961,
    y1: 7.44675,
    x2: 87.6009,
    y2: 7.44675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2233,
    stopColor: "#3F3C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4857,
    stopColor: "#312F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7667,
    stopColor: "#191819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_334_30690",
    x1: 9.04862,
    y1: 10.0454,
    x2: 45.5782,
    y2: 10.0454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2333,
    stopColor: "#191819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5143,
    stopColor: "#312F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7767,
    stopColor: "#3F3C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444142"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_334_30690",
    x1: 75.4612,
    y1: 9.58038,
    x2: 44.8098,
    y2: 9.58038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2333,
    stopColor: "#191819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5143,
    stopColor: "#312F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7767,
    stopColor: "#3F3C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444142"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.4648 44.8291) scale(11.4189 11.4189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6655 4.35071) scale(3.29793 3.29793)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5507 -0.740978) scale(6.81479 6.81479)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7079 36.3269) scale(25.7746 25.7747)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F02210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B201C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7092 36.3269) scale(25.7783 25.7783)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F02210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B201C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7102 36.3269) scale(25.7766 25.7766)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F02210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B201C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7096 36.3269) scale(25.7789 25.7789)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F02210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B201C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7096 36.3269) scale(25.7766 25.7766)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F02210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B201C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6084 36.1463) scale(26.7247 26.7247)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F02210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B201C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.4412 7.28945) rotate(-0.410396) scale(16.7354 15.7307)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0537634,
    stopColor: "#CC462A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#C93428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#C72527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5211,
    stopColor: "#C62026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#901114"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_334_30690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.0416 25.3297) scale(5.40129)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0483871,
    stopColor: "#4356A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2697,
    stopColor: "#414AA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6678,
    stopColor: "#3A2A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9933,
    stopColor: "#340C93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialService);
export default __webpack_public_path__ + "static/media/special_service.cb096e7cd53b25a00222cc01842e162f.svg";
export { ForwardRef as ReactComponent };